import memoryAxiosInstance from '../../../core/api/memoryAxios';

export const onboardingService = {
  check: async (userUuid: string) => {
    const response = await memoryAxiosInstance.get(
      `/api/v1/onboarding/${userUuid}/check`
    );
    return response.data;
  },
  finish: async ({
    userUuid,
  }: {
    userUuid: string;
  }): Promise<{
    message: string;
    finishedOnboarding: boolean;
  }> => {
    const response = await memoryAxiosInstance.patch(
      `/api/v1/onboarding/${userUuid}/finish`
    );
    return response.data;
  },
  toogle: async ({
    userUuid,
    shouldShow,
  }: {
    userUuid: string;
    shouldShow: boolean;
  }) => {
    const patch = shouldShow ? 'should-show' : 'dont-show-again';
    const response = await memoryAxiosInstance.patch(
      `/api/v1/onboarding/${userUuid}/${patch}`,
      {
        dontShowOnboardingAgain: !shouldShow,
      }
    );
    return response.data;
  },
};
